import { render, staticRenderFns } from "./PrincipalPage.vue?vue&type=template&id=527d391a&lang=pug&"
import script from "./PrincipalPage.ts?vue&type=script&lang=ts&"
export * from "./PrincipalPage.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports